<div class="question-container" [formGroup]="group" [ngClass]="{active: isSelected, interviewQuestion: interviewMode}">
  <div [ngClass]="isConfigInvalid()?'invalid-question':''">
    <div class="question-header" *ngIf="!interviewMode" (click)="selectQuestion()">
      <button type="button" class="btn btn-link float-left" (click)="expanded = !expanded">
        <i aria-hidden="true" class="fa" [ngClass]="{'fa-angle-right': !expanded, 'fa-angle-down': expanded}"></i>
      </button>
      <span class="question-mapkey">
        {{config.mapKeyName}}
      </span>
      <span class="question-mapkey float-right pr-2">
        {{config.answerTypeName}}
      </span>
    </div>
    <div class="question-body" *ngIf="expanded">
      <div class="question-text rendered-quill-content ql-editor" [innerHTML]="questionText"></div>
      <div class="help-text rendered-quill-content ql-editor" [innerHTML]="helpText"
        *ngIf="config.helpText?.length"></div>
      <div class="question-form">
        <mat-form-field *ngIf="!allowDateFormatSelection">
          <input matInput [matDatepicker]="picker" [placeholder]="config?.Placeholder" [formControlName]="pickerFieldName" [attr.data-test-input-type]="inputType"
            (focus)="onFocus()" (dateChange)="onDateChange()" (blur)="onDateChange()" [min]="minDate" [max]="maxDate" [disabled]="isReadOnly()"
            [readonly]="isReadOnly()" appMaskDate>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="group.get(pickerFieldName)?.hasError('required')">required</mat-error>
          <mat-error *ngIf="group.get(pickerFieldName)?.hasError('matDatepickerMin')">Minimum value is {{minDate}}</mat-error>
          <mat-error *ngIf="group.get(pickerFieldName)?.hasError('matDatepickerMax')">Maximum value is {{maxDate}}</mat-error>
          <mat-error *ngIf="group.get(pickerFieldName)?.hasError('validationError')">{{group.get(config.id)?.errors.validationError}}</mat-error>
        </mat-form-field>


          <mat-form-field *ngIf="allowDateFormatSelection && !isShortDate" dateFormat1>
              <input matInput [matDatepicker]="picker" [placeholder]="config?.Placeholder" [formControlName]="pickerFieldName" [attr.data-test-input-type]="inputType"
                (focus)="onFocus()" (dateChange)="onDateChange()" (blur)="onDateChange()" [min]="minDate" [max]="maxDate" [disabled]="isReadOnly()"
                [readonly]="isReadOnly()" appMaskDate>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="group.get(pickerFieldName)?.hasError('required')">required</mat-error>
              <mat-error *ngIf="group.get(pickerFieldName)?.hasError('matDatepickerMin')">Minimum value is {{minDate}}</mat-error>
              <mat-error *ngIf="group.get(pickerFieldName)?.hasError('matDatepickerMax')">Maximum value is {{maxDate}}</mat-error>
              <mat-error *ngIf="group.get(pickerFieldName)?.hasError('validationError')">{{group.get(config.id)?.errors.validationError}}</mat-error>
            </mat-form-field>                     
            <mat-form-field *ngIf="allowDateFormatSelection && isShortDate" dateFormat2>
              <input matInput [matDatepicker]="mmyyPicker" [placeholder]="config?.Placeholder" [formControlName]="pickerFieldName" 
                [attr.data-test-input-type]="inputType" 
                (blur)="onDateChange()" 
                (dateChange)="onDateChange()"
                (focus)="onFocus()" [min]="minDate" [max]="maxDate" [disabled]="isReadOnly()"
                [readonly]="isReadOnly()" appMaskDate2>
              <mat-datepicker-toggle matSuffix [for]="mmyyPicker"></mat-datepicker-toggle>
              <mat-datepicker #mmyyPicker startView="year"
                (monthSelected)="setMonthAndYear($event, mmyyPicker)"></mat-datepicker>
              <mat-error *ngIf="group.get(pickerFieldName)?.hasError('required')">required</mat-error>
              <mat-error *ngIf="group.get(pickerFieldName)?.hasError('matDatepickerMin')">Minimum value is {{minDate}}</mat-error>
              <mat-error *ngIf="group.get(pickerFieldName)?.hasError('matDatepickerMax')">Maximum value is {{maxDate}}</mat-error>
              <mat-error *ngIf="group.get(pickerFieldName)?.hasError('validationError')">{{group.get(config.id)?.errors.validationError}}</mat-error>
          </mat-form-field>
      </div>
      <app-field-details [question]="config" [form]="group" [readOnlyMode]="isReadOnly()"></app-field-details>
    </div>
  </div>
</div>
